import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const mapStateToProps = ({ language, retailerSettings: { display_name: displayName, name } }) => ({
  language,
  displayName,
  name,
});

const StyledFootnote = styled.span`
  color: #7a7a7a;
  margin-bottom: 1.5rem;
  display: block;
  font-size: 0.75rem;
`;

const StripeFooter = ({ language, id, displayName, name }) => {
  const footnote = language[`returns.stripe.${id}.footnote`];
  if (!footnote) return null;
  return (
    <StyledFootnote
      dangerouslySetInnerHTML={{ __html: footnote.replace('{retailer}', displayName || name) }}
    />
  );
};

StripeFooter.defaultProps = {
  language: {},
  name: '',
  displayName: '',
};

StripeFooter.propTypes = {
  language: PropTypes.object,
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  displayName: PropTypes.string,
};

export default connect(mapStateToProps)(StripeFooter);
